import { sendFeedback } from '../../services/userVoiceReports';
import TailoredActionName from '../../store/schema/telemetry/TailoredActionName';
import populateFeedbackDataPoint from 'owa-txp/lib/utils/telemetry/populateFeedbackDataPoint';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';
import { TxpDatapoint } from 'txp-data';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';

/**
 * Telemetry callback when 'send feedback' clicked with feedbackDataPoint
 */
export default function onSendFeedbackHandler(
    onFeedbackClicked: (txpDatapoint: TxpDatapoint, datapointName: string) => void,
    entityNamesMap: number,
    origin: string,
    txpStatus: TxpStatus,
    txpConfiguration: TxpConfiguration
) {
    sendFeedback();

    if (onFeedbackClicked) {
        const dataPoint = populateFeedbackDataPoint(
            TailoredActionName.Feedback,
            entityNamesMap,
            origin,
            txpStatus,
            txpConfiguration
        );
        onFeedbackClicked(dataPoint, TxpDataPointNames.TXPUserVoice);
    }
}
